import { useMatch } from 'react-router-dom';
import { pages } from '../routes/config';

export const useIsArtistPage = (): boolean => {
  const isArtist = useMatch(pages.ARTIST) !== null;
  const isArtistFromLocation = useMatch(pages.ARTIST_FROM_LOCATION) !== null;

  return isArtist || isArtistFromLocation;
};
